import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-sales-trends-cell-renderer",
  templateUrl: "./sales-trends-cell-renderer.component.html",
  styleUrls: ["./sales-trends-cell-renderer.component.scss"],
})
export class SalesTrendsCellRendererComponent implements OnDestroy{
  params;
  trend: string;
  private destroy$ = new Subject<void>();
  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    this.params = params;
    this.params.value= Number(this.params.value);
    if(this.params.col){
      this.params.difference = this.params.data['G'+ this.params.col + this.params.data.Value+ 'Diff'];
    }
    this.getDifference();
  }
  
  getDifference() {
    if (this.params.difference > 0) {
      this.trend = "up";
    } else if (this.params.difference < 0) {
      this.trend = "down";
    }else if(this.params.difference == 0){
      this.trend = null;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
